module.exports = __webpack_public_path__ + "img/一体式直流桩02.47.16d1714a.png";